import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { headerStyles } from "@dana/Overrides/Pages/Header";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

headerStyles.utilityNavigationContainer = mergeToNew(headerStyles.utilityNavigationContainer, {
    isFullWidth: true,
    gap: 0,
    css: css`
        background: ${themeColors.primary.black};
        padding: 16px 0;
    `,
});

headerStyles.breadcrumbSkipHeader = mergeToNew(headerStyles.breadcrumbSkipHeader, {
    css: css`
        &&&&.breadcrumb-header {
            max-width: 1440px;
            flex-basis: 1440px;
            margin: 0 auto;
        }

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        padding: 16px;
                    `,
                    css`
                        padding: 16px;
                    `,
                    css`
                        padding: 16px;
                    `,
                    css`
                        padding: 16px 40px;
                    `,
                    css`
                        padding: 16px 40px;
                    `,
                ],
                "min",
            )}
    `,
});

headerStyles.utilityNavigationWrapper = mergeToNew(headerStyles.utilityNavigationWrapper, {
    css: css`
        width: 100%;
        max-width: 1440px;
        margin: 0 auto !important;
        display: flex;
        justify-content: right;
        align-items: center;
        padding: 0px;

        [class*="LoadingSpinnerStyle"] {
            display: none;
        }

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        gap: 16px;
                    `,
                    css`
                        gap: 16px;
                    `,
                    css`
                        gap: 24px;
                    `,
                    css`
                        gap: 24px;
                    `,
                    css`
                        gap: 24px;
                    `,
                ],
                "min",
            )}

        > div {
            width: auto;
            display: flex;
        }
    `,
});

headerStyles.utilityTopNavigationContainer = mergeToNew(headerStyles.utilityTopNavigationContainer, {
    isFullWidth: true,
    gap: 0,
    css: css`
        background: ${themeColors.primary.black};
        padding: 0px;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        display: none;
                    `,
                    null,
                    null,
                    css`
                        display: block;
                    `,
                ],
                "min",
            )}
    `,
});

headerStyles.utilityTopNavigationWrapper = mergeToNew(headerStyles.utilityTopNavigationWrapper, {
    gap: 0,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        padding: 16px 16px 0px 24px;
                    `,
                    css`
                        padding: 16px 24px 0px 24px;
                    `,
                    css`
                        padding: 16px 24px 0px 24px;
                    `,
                    css`
                        padding: 16px 40px 0px 40px;
                    `,
                    css`
                        padding: 16px 0px 0px 0px;
                    `,
                ],
                "min",
            )}
    `,
    offsetCss: css`
        padding: 0px;
        .utility-top-navigation-container {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            column-gap: 24px;

            > [class*="Wrapper"] {
                display: flex;
                width: auto;
            }

            [class*="LoadingSpinnerStyle"] {
                display: none;
            }
        }
    `,
});

headerStyles.headerUtilityLogo = mergeToNew(headerStyles.headerUtilityLogo, {
    css: css`
        display: none;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        display: flex;
                        margin-right: auto !important;
                    `,
                    css`
                        display: flex;
                        margin-right: auto !important;
                    `,
                ],
                "max",
            )}
    `,
});

headerStyles.headerUtilityMenu = mergeToNew(headerStyles.headerUtilityMenu, {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        display: block;
                    `,
                    css`
                        display: block;
                    `,
                    css`
                        display: block;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                ],
                "min",
            )}
    `,
});

headerStyles.mainHeader = mergeToNew(headerStyles.mainHeader, {
    css: css`
        background: ${themeColors.primary.richBlack};
        display: flex;
        width: 100%;

        &.isSticky {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 1000;
        }
        padding: 16px 40px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        padding: 16px;
                    `,
                    css`
                        padding: 16px;
                    `,
                    css`
                        padding: 16px;
                    `,
                    css`
                        padding: 16px 40px;
                    `,
                ],
                "min",
            )}
    `,
});

headerStyles.mainHeaderContainerWrapper = mergeToNew(headerStyles.mainHeaderContainerWrapper, {
    width: 12,
    css: css`
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        gap: 16px;
        max-width: 1440px;
        margin: auto !important;
    `,
});

headerStyles.headerBrowseProducts = mergeToNew(headerStyles.headerBrowseProducts, {
    css: css`
        min-width: 185px;
        flex-shrink: 0;
    `,
});

headerStyles.page = mergeToNew(headerStyles.page, {
    fullWidth: [true, true, false, false, false],
    css: css`
        background: ${themeColors.primary.richBlack};
    `,
});

headerStyles.breadcrumWrapperContainer = mergeToNew(headerStyles.breadcrumWrapperContainer, {
    isFullWidth: true,
    offsetCss: css`
        background: ${themeBackgrounds.offWhite};
    `,
    css: css`
        padding: 15px;
    `,
});

headerStyles.extraLinks = mergeToNew(headerStyles.extraLinks, {
    css: css`
        & > [class*="Wrapper"] {
            display: flex;
            align-self: center;
            gap: 24px;
        }
    `,
});
